import * as types from '../../mutationTypes';

export default {
  /* eslint-disable no-param-reassign */
  [types.SET_TOC_STATE](state, value) {
    state.tocState = value;
  },

  [types.INITIAL_DATA_MANAGER](state, value) {
    state.initialised = value;
  },

  [types.SET_MODULE_STATE](state, value) {
    state.moduleState = value;
  },

  [types.UPDATE_MODULE_FINISHED](state, value) {
    state.moduleUpdated = value;
  },

  [types.PAGE_HISTORY](state, value) {
    state.pageHistory = value;
  },

  [types.CLEAR_PAGE_HISTORY](state) {
    state.pageHistory = [];
  },

  [types.SET_PAGE_COMMIT_OID](state, value) {
    state.pageCommitOID = value;
  },

  [types.SET_PAGE_COMMIT_TIMESTAMP](state, value) {
    state.pageCommitTimestamp = value;
  },

  [types.SET_UNPUBLISHED_UPDATES_STATE](state, value) {
    state.unpublishedUpdatesState = value;
  }
  /* eslint-enable no-param-reassign */
};
